import React from 'react';
import moment from 'moment';
import DatePicker from 'react-bootstrap-date-picker';
import TimePicker from 'react-bootstrap-time-picker';
import Select from 'react-select';
import 'whatwg-fetch';
import { postEntity } from 'src/utils/entityApi';
import data_priority from 'src/data/priority';
import data_criticity from 'src/data/criticity';
import InputFormAssociated from '../input/inputFormAssociated';
import withAuth from 'src/hoc/withAuth';

const apiEmployeeShow = '/api/employee/';

const oriState = {
  dataEmployee: undefined,
  employeeSelected: '',
  title: undefined,
  text: undefined,
  dateDeadLine: undefined,
  timeDeadLine: 12 * 3600,
  priority: -1,
  criticity: -1,
  employeesConcerned: [],
};

class ModalTaskPost extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputSelectChange = this.handleInputSelectChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.reset = this.reset.bind(this);
    this.close = this.close.bind(this);
    this.checkFormValid = this.checkFormValid.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
    this.componentDidMount();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  handleDateChange(value, formattedValue) {
    this.setState({
      //value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
      dateDeadLine: formattedValue, // Formatted String, ex: "11/19/2016"
    });
  }
  handleTimeChange(timeDeadLine) {
    this.setState({ timeDeadLine });
  }
  handleInputSelectChange(val) {
    console.log(val);

    //let tab = this.state.employeesConcerned;

    this.setState({
      employeeSelected: val,
      employeesConcerned: val,
    });
  }

  componentDidMount() {
    let queryURL = apiEmployeeShow;
    let graphQL = '{ employees{ id, firstname, lastname } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['employees']) {
            this.setState({
              dataEmployee: data['data']['employees'],
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch list employees entity: \n' + error);
        }.bind(this)
      );
  }

  checkFormValid() {
    return (
      this.state.title &&
      this.state.priority &&
      this.state.priority !== -1 &&
      this.state.criticity &&
      this.state.criticity !== -1 &&
      this.state.dateDeadLine &&
      this.state.timeDeadLine &&
      this.state.employeesConcerned &&
      this.state.employeesConcerned.length !== 0
    );
  }

  render() {
    if (this.props.isOpen === false) return null;

    const { dataEmployee } = this.state;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>Créer Tâche</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <form>
              <div className='modal-body'>
                <div className='form-group'>
                  <label>Titre</label>
                  <input
                    name='title'
                    value={this.state.title}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    placeholder='Retrouver la tâche plus tard'
                  />
                </div>
                <div className='form-group'>
                  <label>Texte</label>
                  <textarea
                    name='text'
                    value={this.state.text}
                    onChange={this.handleInputChange}
                    className='form-control'
                    placeholder='Description de la tâche (facultatif)'
                  />
                </div>
                <div className='form-group'>
                  <label>Criticité</label>
                  <select
                    name='criticity'
                    value={this.state.criticity}
                    onChange={this.handleInputChange}
                    className='form-control'
                  >
                    <option value={-1}>Sélectionner criticité</option>
                    {data_criticity ? (
                      Object.entries(data_criticity).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                </div>
                <div className='form-group'>
                  <label>Priorité</label>
                  <select
                    name='priority'
                    value={this.state.priority}
                    onChange={this.handleInputChange}
                    className='form-control'
                  >
                    <option value={-1}>Sélectionner priorité</option>
                    {data_priority ? (
                      Object.entries(data_priority).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                </div>
                <div className='form-group'>
                  <label>Date Limite</label>
                  <DatePicker
                    calendarContainer={this}
                    name='dateDeadLine'
                    defaultValue={moment().format('YYYY-MM-DD')}
                    value={this.state.dateDeadLine}
                    onChange={this.handleDateChange}
                    dateFormat='YYYY-MM-DD'
                  />
                </div>
                <div className='form-group'>
                  <label>Heure Limite</label>
                  <TimePicker
                    format={24}
                    initialValue={'12:00'}
                    onChange={this.handleTimeChange}
                    value={this.state.timeDeadLine}
                  />
                </div>
                <div className='form-group'>
                  <label>Employés associés</label>
                  <Select
                    multi={true}
                    className='inputModalSelect'
                    name='employeeSelected'
                    value={this.state.employeeSelected}
                    labelKey={'firstname'}
                    valueKey={'id'}
                    options={dataEmployee}
                    onChange={this.handleInputSelectChange}
                    noResultsText={'Aucun résultat'}
                    placeholder={'Nom'}
                    clearValueText={'Supprimer'}
                  />
                </div>
                {this.props.entityAssociated && <InputFormAssociated entityAssociated={this.props.entityAssociated} />}
              </div>
              <div className='modal-actions'>
                <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                  Annuler
                </button>
                <button
                  onClick={this.handleSubmit}
                  type='button'
                  className='btn-link modal-action'
                  data-dismiss='modal'
                >
                  <strong>Créer</strong>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  handleSubmit() {
    if (this.props.onPostResult) {
      if (this.checkFormValid()) {
        let json = {
          task: {
            title: this.state.title,
            text: this.state.text ? this.state.text : '', // optional
            deadline: moment(this.state.dateDeadLine).seconds(this.state.timeDeadLine).format('YYYY-MM-DD HH:mm'),
            priority: this.state.priority,
            criticity: this.state.criticity,
          },
        };
        // If present -> set the Major Entity associated
        if (this.props.entityAssociated) {
          json.task['relativeTo'] = {
            [this.props.entityAssociated.type]: {
              id: this.props.entityAssociated.id,
            },
          };
        }
        // If present -> add the employees associated
        if (this.state.employeesConcerned && this.state.employeesConcerned.length > 0) {
          json.task['employeesConcerned'] = this.state.employeesConcerned;
        }

        this.props.onPostResult('task', postEntity(this.props.authFetch, 'task', json));
        this.close();
      } else {
        this.props.openToast(false, 'Certains champs obligatoires sont vides');
      }
    }
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}

export default withAuth(ModalTaskPost);
